// Validaciones y formatos del onboarding.

// RFC de persona moral (12) o física (13): letras, 6 dígitos de fecha y homoclave.
export const isValidRfc = (value) => /^[A-ZÑ&]{3,4}\d{6}[A-Z0-9]{3}$/.test(String(value || '').trim().toUpperCase())

export const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(value || '').trim())

// CLABE interbancaria: exactamente 18 dígitos.
export const clabeDigits = (value) => String(value || '').replace(/\D/g, '').slice(0, 18)
export const isValidClabe = (value) => clabeDigits(value).length === 18

// Se muestra en grupos de 6 para poder verificarla a simple vista.
export const formatClabe = (value) => clabeDigits(value).replace(/(\d{6})(?=\d)/g, '$1 ')

export const formatMoney = (n) =>
  Number(n || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 0, maximumFractionDigits: 2 })

export const todayYmd = () => new Date().toLocaleDateString('en-CA')

// Suma años a una fecha 'YYYY-MM-DD' (29 de febrero cae en 28).
export function addYearsYmd(ymd, years) {
  const [y, m, d] = ymd.split('-').map(Number)
  const lastDay = new Date(y + years, m, 0).getDate()
  return `${y + years}-${String(m).padStart(2, '0')}-${String(Math.min(d, lastDay)).padStart(2, '0')}`
}

export function formatLongDate(ymd) {
  if (!ymd) return ''
  const [y, m, d] = ymd.split('-').map(Number)
  return new Date(y, m - 1, d).toLocaleDateString('es-MX', { day: 'numeric', month: 'long', year: 'numeric' })
}

// Escalación anual: un aumento compuesto en cada aniversario antes de que venza el contrato.
export function buildEscalations(startYmd, endYmd, rent, percent) {
  const out = []
  if (!startYmd || !endYmd || !(rent > 0) || !(percent > 0)) return out
  let current = Number(rent)
  for (let n = 1; n <= 30; n++) {
    const date = addYearsYmd(startYmd, n)
    if (date >= endYmd) break
    current = Math.round(current * (1 + percent / 100) * 100) / 100
    out.push({ date, newRent: current })
  }
  return out
}

export const ZONE_PRESETS = ['Zona A', 'Zona B', 'Zona C', 'Zona D']
export const CUSTOM_ZONE = '__custom__'

// Fondo sutil por zona para las tarjetitas del grid.
const ZONE_COLORS = { 'zona a': '#dbeafe', 'zona b': '#d1fae5', 'zona c': '#fef3c7', 'zona d': '#ede9fe' }
export const zoneColor = (zone) => (zone ? ZONE_COLORS[zone.trim().toLowerCase()] || '#e0f2fe' : '#f1f5f9')

export const TEAM_ROLES = [
  { value: 'TECHNICIAN', label: 'Técnico' },
  { value: 'OPERATIONS', label: 'Operativo' },
  { value: 'FINANCE', label: 'Financiero' },
  { value: 'MAINTENANCE_SUPERVISOR', label: 'Supervisor de mantenimiento' },
]

export const STEPS = [
  { key: 'park', label: 'Tu parque', minutes: 2 },
  { key: 'plots', label: 'Tus naves', minutes: 3 },
  { key: 'tenant', label: 'Tu inquilino', minutes: 1 },
  { key: 'contract', label: 'Tu contrato', minutes: 2 },
  { key: 'billing', label: 'Cobranza', minutes: 1 },
]